import { render } from "./RegistroView.vue?vue&type=template&id=f2702b78"
import script from "./RegistroView.vue?vue&type=script&lang=js"
export * from "./RegistroView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__